export default () => ({
  locale: "en-US",
  mobile: false,
  storeVersion: null,
  online: true,
  filtersVisible: {},
  filters: {},
});
